import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { PetType } from 'constants/pet-type';
import { AI_WEIGHT_ENTRY_POINTS, AiWeightEntryPointId } from 'modules/ai-weight-analyzer/constants';

const SUPPRESSION_TTL_MS = 24 * 60 * 60 * 1000;

interface OpenOptions {
  entryPointId: AiWeightEntryPointId;
  petType: PetType;
}

interface AiWeightAnalyzerStore {
  isOpen: boolean;
  triggeredFrom: AiWeightEntryPointId;
  petType: PetType;
  engagedAt: number | null;
  open: (options: OpenOptions) => void;
  close: () => void;
  markEngaged: () => void;
}

export const isAiWeightSuppressed = (engagedAt: number | null): boolean =>
  engagedAt !== null && Date.now() - engagedAt < SUPPRESSION_TTL_MS;

export const useAiWeightAnalyzerStore = create<AiWeightAnalyzerStore>()(
  persist(
    (set) => ({
      isOpen: false,
      triggeredFrom: AI_WEIGHT_ENTRY_POINTS.overlay,
      petType: PetType.Dog,
      engagedAt: null,
      open: ({ entryPointId, petType }) =>
        set({ isOpen: true, triggeredFrom: entryPointId, petType }),
      close: () => set({ isOpen: false }),
      markEngaged: () => set({ engagedAt: Date.now() }),
    }),
    {
      name: 'pd:ai-weight-analyzer:v1',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ engagedAt: state.engagedAt }),
    }
  )
);
